<template>
  <business-trip-request-employee-form v-model="employee" @input="change" refreshable printable @print="print"
                                       @refresh="refresh" @close="close" @save="save" v-if="loaded" :editable="editable" />
  <h2 v-else>Loading...</h2>
</template>

<script>
import Promise from 'promise-polyfill'
import Vuex from 'vuex'
import _ from 'lodash'

import BusinessTripRequestEmployeeForm from './BusinessTripRequestEmployeeForm'

const btRequestStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Request')
const btRequestEmployeesStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Employees')
const btRequestExpensesStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Expenses')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  name: 'BusinessTripRequestEmployeeDetail',
  components: {
    BusinessTripRequestEmployeeForm
  },
  props: {
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    backRoute: {
      type: [String, Object],
      required: true
    }
  },
  data () {
    return {
      employee: {},
      loaded: false,
      modified: false
    }
  },
  methods: {
    ...btRequestEmployeesStore.mapActions({
      getEmployeeById: 'getEmployeeById',
      updateEmployee: 'updateEmployee',
      printSppd: 'printSppd',
      printSprpd: 'printSprpd'
    }),
    ...btRequestStore.mapActions({
      getRequest: 'getRequest'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    ...btRequestExpensesStore.mapActions({
      getExpenses: 'getExpenses'
    }),
    loadResources () {
      const self = this
      self.getRequest({vueinstance: self, id: self.$route.params.id})

        .then(res => {
          self.request = _.cloneDeep(res.content)
          const resources = [
            self.getEmployeeById({vueinstance: self, id: self.$route.params.id, empid: self.$route.params.empid}),
            self.getExpenses({vueinstance: self, id: self.$route.params.id, empid: self.$route.params.empid})
          ]
          Promise.all(resources)
            .then(res1 => {
              self.employee = _.cloneDeep(res1[0])
              self.employee.expenses = _.cloneDeep(res1[1])
              self.loaded = true
            })
            .catch(err => self.$error(err))
        })
        .catch(err => self.$error(err))
    },
    change () {
      this.modified = true
    },
    close () {
      const self = this
      if (self.modified) {
        const yesHandler = () => {
          self.$router.replace({name: this.backRoute, params: {id: self.$route.params.id, editable: this.editable}})
          self.closeConfirmation()
        }

        const noHandler = () => {
          self.closeConfirmation()
        }

        this.showConfirmation({
          message: 'Are you sure?',
          title: 'Closing. Modified Business Trip Request Employee ' + this.employee.employee.name + ' will not saved',
          buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]
        })
      } else {
        self.$router.replace({name: this.backRoute, params: {id: self.$route.params.id, editable: this.editable}})
      }
    },
    refresh (employee) {
      const self = this
      self.loaded = false

      self.getEmployeeById({vueinstance: self, id: self.$route.params.id, empid: self.$route.params.empid})
        .then(res => {
          self.employee = _.cloneDeep(res)
          self.loaded = true
          self.modified = false
        })
    },
    save (employee) {
      const self = this

      const data = _.cloneDeep(employee)
      data.expenses = []

      self.updateEmployee({vueinstance: self, id: self.$route.params.id, emp: data})
        .then(res => {
          self.loaded = self
          self.employee = _.cloneDeep(res)
          self.loaded = true
          self.modified = false
          self.$success('Business Trip Request Employee ' + self.employee.employee.name + ' saved')
          self.$router.replace({name: this.backRoute, params: {id: self.$route.params.id, editable: this.editable}})
        })
        .catch(err => self.$error(err))
    },
    print (value) {
      const self = this
      const printReport = (type) => {
        const emp = _.cloneDeep(value)
        const empid = emp.id
        delete emp.id
        self['print' + type]({vueinstance: self, id: emp.sppd.id, empid: empid})
          .then(res => {
            let url = URL.createObjectURL(res)
            window.open(url)
          }).catch(err => self.$error(err))
      }
      self.showConfirmation({
        title: 'Please choose print type',
        message: '',
        buttons: [
          {label: 'SPPD', handler: () => printReport('Sppd')},
          {label: 'SPrPD', handler: () => printReport('Sprpd')},
          {label: 'Close', handler: () => self.closeConfirmation()}
        ]
      })
    }
  },
  mounted () {
    if (!this.loaded) {
      this.loadResources()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.loadResources())
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/business-trip/BusinessTripRequestEmployeeDetail.vue